export default __webpack_public_path__ + "static/media/Snd_TryA.9f03ee66.mp3";